import {
  FullNormalizedItem,
  NormalizedDataState,
} from '@wix/editor-platform-host-integration-apis';

import { getIdentifierFromRoleAndSubRole } from './getIdentifierForRoleAndSubRole';

export const setCompRefsAndCheckedState = (
  data: NormalizedDataState,
  item: FullNormalizedItem,
): NormalizedDataState => {
  const id = getIdentifierFromRoleAndSubRole(item.identifier);

  if ('compRef' in item && item.compRef) {
    return {
      checkedState: {
        ...data.checkedState,
        [id]: !item.isCollapsed,
      },
      compRefsMap: {
        ...data.compRefsMap,
        [id]: item.compRef,
      },
    };
  }

  return data;
};
